import { Button, Modal, Form, Row, Col, Input, message } from "antd";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { handleCreateSite } from "../../../api/distributions";
import { useEffect } from "react";
import TextArea from "antd/es/input/TextArea";

export default function CreateSite({
  isVisible,
  setVisible,
  distribution,
}: any) {
  const queryClient = useQueryClient();
  const [form] = Form.useForm();

  const { mutate, isPending } = useMutation({
    mutationFn: handleCreateSite,
    onSuccess: () => {
      message.success("Created Successfully");
      form.resetFields();
      queryClient.invalidateQueries({ queryKey: ["distributions"] });
      setVisible(false);
    },
    onError: () => {
      message.error("Something went wrong");
    },
  });

  const onSubmit = async () => {
    const values = await form.getFieldsValue();
    const data = {
      ...values,
    };
    await mutate({ id: distribution?._id, data });
  };

  const clearForm = async () => {
    form.resetFields();
  };

  useEffect(() => {}, [distribution]);

  return (
    <Modal
      open={isVisible}
      title={`Add Allocation :- ${distribution?.name}`}
      onCancel={() => setVisible(false)}
      footer={[
        <Button key="back" onClick={clearForm}>
          Clear
        </Button>,
        <Button
          key="submit"
          form="createDistSite"
          htmlType="submit"
          type="primary"
          onSubmit={onSubmit}
          loading={isPending}
        >
          Create
        </Button>,
      ]}
    >
      <Form
        id="createDistSite"
        form={form}
        name="normal_login"
        className="login-form"
        onFinish={onSubmit}
        layout="vertical"
      >
        <Row gutter={[16, 0]}>
          <Col xs={{ span: 24 }} lg={{ span: 24 }}>
            <Form.Item
              name="unit"
              label={"Bandwidth (Mbps)"}
              rules={[
                {
                  required: true,
                  message: "Please enter bandwidth",
                },
              ]}
            >
              <Input type="text" placeholder="Bandwidth" />
            </Form.Item>
          </Col>
          <Col xs={{ span: 24 }} lg={{ span: 24 }}>
            <Form.Item
              name="description"
              label={"Description"}
              rules={[
                {
                  required: true,
                  message: "Please enter description",
                },
              ]}
            >
              <TextArea placeholder="Description" />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
}
